const DOWNLOAD_URL = 'download_url'
const PROXY_URL = 'proxy_url'
const SPHERICAL_PHOTO = 'spherical_photo'

// Maps a Rails photo payload to the shape PhotoViewer expects. A 360 photo is served through the
// Proxy url, the only one the viewer can read pixels from. Alt falls back to the file name.
const buildViewerPhotos = (photos, alt = null) => photos.map(photo => ({
  url: photo[SPHERICAL_PHOTO] ? photo[PROXY_URL] : photo.url,
  downloadUrl: photo[DOWNLOAD_URL],
  alt: alt || photo.filename,
  spherical: Boolean(photo[SPHERICAL_PHOTO])
}))

export default buildViewerPhotos
